<template>
  <div class="ur-basic">
    <!-- Tab Bar -->
    <div class="ur-basic-tabbar">
      <button
        class="ur-basic-tab"
        :class="{ 'is-active': activeTab === 'landowner' }"
        @click="activeTab = 'landowner'"
      >
        {{ $t('URBANRENEWAL_ADMIN.STAT.TAB_LANDOWNER') }}
      </button>
      <button
        class="ur-basic-tab"
        :class="{ 'is-active': activeTab === 'housing' }"
        @click="activeTab = 'housing'"
      >
        {{ $t('URBANRENEWAL_ADMIN.STAT.TAB_HOUSING') }}
      </button>
      <button
        class="ur-basic-tab"
        :class="{ 'is-active': activeTab === 'parking' }"
        @click="activeTab = 'parking'"
      >
        {{ $t('URBANRENEWAL_ADMIN.STAT.TAB_PARKING') }}
      </button>
    </div>

    <!-- Tab Content -->
    <div class="ur-basic-content">
      <LandownerStatTab
        v-if="activeTab === 'landowner'"
        :project-id="currentProjectId"
      />
      <HousingStatTab
        v-else-if="activeTab === 'housing'"
        :project-id="currentProjectId"
      />
      <ParkingStatTab
        v-else-if="activeTab === 'parking'"
        :project-id="currentProjectId"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import LandownerStatTab from './LandownerStatTab.vue';
import HousingStatTab from './HousingStatTab.vue';
import ParkingStatTab from './ParkingStatTab.vue';

export default {
  name: 'UrbanRenewalAdminStatistics',

  components: { LandownerStatTab, HousingStatTab, ParkingStatTab },

  data() {
    return {
      activeTab: 'landowner',
    };
  },

  computed: {
    ...mapState('urbanRenewalAdmin', ['currentProjectId']),
  },
};
</script>
